import { XInput } from '@playcastdotio/CoreTypes';

export type TouchTracker = {
  touches: {
    [key: number]: {
      identifier: number;
      target: HTMLElement;
      start: {
        x: number;
        y: number;
      };
    };
  };
};

export type MobileGamepadState = XInput & TouchTracker;

let mobileGamepad: MobileGamepadState = {
  wButtons: 0,
  bLeftTrigger: 0,
  bRightTrigger: 0,
  sThumbLX: 0,
  sThumbLY: 0,
  sThumbRX: 0,
  sThumbRY: 0,
  touches: {},
};

const subs = {
  gamepad: [] as ((gamepad: MobileGamepadState) => void)[],
};

const emitGamepadChange = () => {
  for (const s of subs.gamepad) {
    s(mobileGamepad);
  }
};

export const gamepadStore = {
  updateGamepad(g: MobileGamepadState) {
    mobileGamepad = g;
    emitGamepadChange();
  },
  subscribeGamepad(callback: (gamepad: MobileGamepadState) => void) {
    subs.gamepad = [...subs.gamepad, callback];
    return () => {
      subs.gamepad = subs.gamepad.filter((s) => s !== callback);
    };
  },
  getGamepad() {
    return mobileGamepad;
  },
};
